import { render, staticRenderFns } from "./DepartmentTile.vue?vue&type=template&id=6bc997af&scoped=true&lang=pug&"
import script from "./DepartmentTile.vue?vue&type=script&lang=js&"
export * from "./DepartmentTile.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentTile.vue?vue&type=style&index=0&id=6bc997af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc997af",
  null
  
)

export default component.exports